'use client';

import { c as _c } from "react/compiler-runtime";
import { CustomErrorModal } from '@app/_components/error/CustomErrorModal';
import { ErrorModal } from '@app/_components/error/ErrorModal';
import { SidebarDialog } from '@app/_components/SidebarDialog';
import { CenterDialog } from '@components/dialogs/CenterDialog';
import { useIsPopupWindow } from '@lib/hooks/useIsPopupWindow';
import type { FC } from 'react';
export const GlobalDialogs: FC = () => {
  const $ = _c(2);
  const isPopup = useIsPopupWindow();
  if (isPopup) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <><ErrorModal /><CustomErrorModal /><CenterDialog /></>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><ErrorModal /><CustomErrorModal /><SidebarDialog /><CenterDialog /></>;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};